import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Protocol } from "../../utils/types/protocol/protocol.type";
import { ProtocolMapper } from "../../utils/mappers/protocol/protocol.mapper";
import { PROTOCOL_ENDPOINTS } from "../../components/mediaManager/admon/protocol/protocol-endpoints";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class ProtocolService extends BaseApiService<Protocol> {
    model = Protocol;
    mapper = new ProtocolMapper();
    apiEndPoint: any = PROTOCOL_ENDPOINTS;

    create(data: Protocol): Observable<boolean> {
        return this.http.post<boolean>(this.apiEndPoint.list, data).pipe(
            map((res) => {
                return res;
            })
        );
    }
    getList(filter?: FilterType): Observable<PagedApiResponse<Protocol>> {
        let params = new HttpParams();
        params = params.append("limit", filter.limit);
        params = params.append("offset", filter.offset);

        return this.http.get(this.apiEndPoint.list, { params }).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    update(data: Protocol): Observable<boolean> {
        const { id } = data;
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, data);
    }

    delete(id: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
